import {
  Button,
  InputLabel,
  Typography,
  Grid,
  Tab,
  Tabs,
  TextField,
  Box,
  FormControlLabel,
  Checkbox,
  DialogActions,
  ButtonGroup,
} from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import { styled } from "@mui/material/styles";
import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";

import { language } from "../../../../../language";
import FolderSystem from "../../../../FolderTree/FolderSystem";
import GenericModal from "../../../../modal-closebtn/index";

const StyledBox = styled(Box)(({ theme }) => ({
  height: "75vh",
}));

const StyledFormControl = styled(Box)(({ theme }) => ({
  padding: "1% 1%",
}));

const StyledFormMargin = styled(Box)(({ theme }) => ({
  margin: "3% 0",
}));

const StyledGridItem = styled(Grid)(({ theme }) => ({
  margin: "7% 0",
}));

const StyledGridItemPadding = styled(Grid)(({ theme }) => ({
  padding: "3% 3%",
}));

const StyledBoxBorder = styled(Box)(({ theme }) => ({
  borderColor: "rgba(0, 0, 0, 0.34)",
}));

const StyledBoxSize = styled(Box)(({ theme }) => ({
  height: "66px",
}));

const StyledGridConfigItem = styled(Grid)(({ theme }) => ({
  margin: "5% 0",
}));

const StyledGridCopyMargin = styled(Grid)(({ theme }) => ({
  marginBottom: "7%",
  marginTop: "2%",
}));

// TAB PANEL
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Typography
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`wrapped-tabpanel-${index}`}
      aria-labelledby={`wrapped-tab-${index}`}
      {...other}
    >
      {children}
    </Typography>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

// TAB PROPERTIES
function TabProperties(props) {
  const {
    metadadosValue,
    onChangeMetadados,
    fileListValue,
    onChangeFileList,
    taskFields,
    handleCheckMainFile,
  } = props;

  //alterando a lista variaveis do formulário para o componente de autocomplete
  const taskFieldsOptions = taskFields
    ? taskFields.map((item) => ({
        label: item.id,
        value: item.id,
      }))
    : [];

  return (
    <StyledFormControl>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <InputLabel>{language.metadataList}</InputLabel>
          <Autocomplete
            multiple
            options={taskFieldsOptions}
            value={metadadosValue}
            onChange={onChangeMetadados}
            getOptionLabel={(option) => option.label}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                label={language.metadataList}
              />
            )}
          />
        </Grid>
        <Grid item xs={12}>
          <InputLabel>{language.fileList}</InputLabel>
          <Autocomplete
            multiple
            options={taskFieldsOptions}
            value={fileListValue}
            onChange={onChangeFileList}
            getOptionLabel={(option) => option.label}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                label={language.fileList}
              />
            )}
          />
        </Grid>
        <Grid item xs={12}>
          <FormControlLabel
            control={
              <Checkbox
                checked={false}
                onChange={handleCheckMainFile}
                name="mainFile"
              />
            }
            label={language.mainFile}
          />
        </Grid>
      </Grid>
    </StyledFormControl>
  );
}

// TAB CONFIGURATION
function TabConfiguration(props) {
  const {
    parentFolderTemplateName,
    onChangeParentFolderTemplateName,
    selectedFolder,
    onSelectFolder,
  } = props;

  return (
    <StyledFormControl>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <InputLabel>{language.parentFolderTemplateName}</InputLabel>
          <TextField
            fullWidth
            variant="outlined"
            value={parentFolderTemplateName}
            onChange={onChangeParentFolderTemplateName}
            label={language.parentFolderTemplateName}
          />
        </Grid>
        <Grid item xs={12}>
          <InputLabel>{language.selectFolder}</InputLabel>
          <FolderSystem
            onSelectFolder={onSelectFolder}
            selectedFolder={selectedFolder}
          />
        </Grid>
      </Grid>
    </StyledFormControl>
  );
}

// OVERRIDE MODAL ACTIONS
function OverrideModalActions(props) {
  const { handleSave, handleClose, isInvalid } = props;

  return (
    <DialogActions>
      <Button onClick={handleClose} color="primary">
        {language.cancel}
      </Button>
      <Button
        onClick={handleSave}
        color="primary"
        variant="contained"
        disabled={isInvalid}
      >
        {language.save}
      </Button>
    </DialogActions>
  );
}

const ModelerModalGerarMinuta = ({
  saveMinuta,
  businessObject,
  element,
  extensionElements,
  selectBox,
  bpmnFactory,
  taskFields,
}) => {
  const [open, setOpen] = useState(true);
  const [tabValue, setTabValue] = useState(0);
  const [metadadosValue, setMetadadosValue] = useState([]);
  const [fileListValue, setFileListValue] = useState([]);
  const [parentFolderTemplateName, setParentFolderTemplateName] = useState("");
  const [selectedFolder, setSelectedFolder] = useState(null);
  const [mainFile, setMainFile] = useState(false);

  useEffect(() => {
    // Initialize component state
    setOpen(true);
    setTabValue(0);
    setMetadadosValue([]);
    setFileListValue([]);
    setParentFolderTemplateName("");
    setSelectedFolder(null);
    setMainFile(false);
  }, []);

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const handleChangeTab = (event, newValue) => {
    setTabValue(newValue);
  };

  const handleClearState = () => {
    setMetadadosValue([]);
    setFileListValue([]);
    setParentFolderTemplateName("");
    setSelectedFolder(null);
    setMainFile(false);
  };

  const handleFileListChange = (event, newValue) => {
    setFileListValue(newValue);
  };

  const handleMetadataListChange = (event, newValue) => {
    setMetadadosValue(newValue);
  };

  const handleCheckMainFile = (event) => {
    setMainFile(event.target.checked);
  };

  const handleSelectFolder = (event, nodeIds) => {
    setSelectedFolder(nodeIds);
  };

  const handleParentFolderTemplateName = (event, newValue) => {
    setParentFolderTemplateName(newValue);
  };

  const handleSave = () => {
    const minutaData = {
      metadados: metadadosValue,
      fileList: fileListValue,
      parentFolderTemplateName,
      selectedFolder,
      mainFile,
    };

    saveMinuta(
      businessObject,
      element,
      extensionElements,
      selectBox,
      bpmnFactory,
      minutaData,
    );

    handleClearState();
    setOpen(false);
  };

  const isInvalid = !metadadosValue.length && !fileListValue.length;

  return (
    <GenericModal
      title={language.generateMinuta}
      handleClose={handleClose}
      size="lg"
      bigHeight
      open={open}
      handleSubmit={handleSave}
      btnActionTitle={language.confirm}
      disabledAction={isInvalid}
    >
      <StyledBox>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs value={tabValue} onChange={handleChangeTab}>
            <Tab label={language.properties} />
            <Tab label={language.configuration} />
          </Tabs>
        </Box>

        <TabPanel value={tabValue} index={0}>
          <TabProperties
            metadadosValue={metadadosValue}
            onChangeMetadados={handleMetadataListChange}
            fileListValue={fileListValue}
            onChangeFileList={handleFileListChange}
            taskFields={taskFields}
            handleCheckMainFile={handleCheckMainFile}
          />
        </TabPanel>

        <TabPanel value={tabValue} index={1}>
          <TabConfiguration
            parentFolderTemplateName={parentFolderTemplateName}
            onChangeParentFolderTemplateName={handleParentFolderTemplateName}
            selectedFolder={selectedFolder}
            onSelectFolder={handleSelectFolder}
          />
        </TabPanel>
      </StyledBox>
    </GenericModal>
  );
};

ModelerModalGerarMinuta.propTypes = {
  saveMinuta: PropTypes.func,
  businessObject: PropTypes.object,
  element: PropTypes.object,
  extensionElements: PropTypes.object,
  selectBox: PropTypes.object,
  bpmnFactory: PropTypes.object,
  taskFields: PropTypes.array,
};

export default ModelerModalGerarMinuta;
